/*
    Section New Badge
*/

initNewBadges();
$('section.main-section').on('click', handleNewBadge);

function initNewBadges(){
    var newBadges = $('.main-section').find('h5.main-heading .badge.new');

    newBadges.each(function checkLocalStorage(index, badge){
        var badgeSectionID = $(badge).parents('.main-section').attr('id');
        var badgeLastModified = $(badge).data('last-modified');
        var badgeSectionLocalStorage = JSON.parse(localStorage.getItem(badgeSectionID));

        if(badgeSectionLocalStorage === null || badgeSectionLocalStorage.lastModified !== badgeLastModified){
            updateNewBadgeLocalStorage(badgeSectionID, badgeLastModified);
            showNewBadge(badge);
        } else if(badgeSectionLocalStorage.status === 'notViewed'){
            showNewBadge(badge);
        } else if($(badge).data('hide-on-click') === undefined){
            showNewBadge(badge);
        }
    });
}

function handleNewBadge(){
    var badge = $(this).find('h5.main-heading .badge.new');
    if(badge.length > 0){
        var badgeSectionID = $(this).attr('id');
        var badgeSectionLocalStorage = JSON.parse(localStorage.getItem(badgeSectionID));
        var hideBadgeOnClick = badge.data('hide-on-click') !== undefined;
        var badgeIsVisible = badge.hasClass('is-active');

        if( hideBadgeOnClick || badgeIsVisible ){ 
            if(badgeSectionLocalStorage !== null && badgeSectionLocalStorage.status === 'notViewed'){
                badgeSectionLocalStorage.status = 'viewed';
                localStorage.setItem(badgeSectionID, JSON.stringify(badgeSectionLocalStorage));
                hideNewBadge(badge);
            }
        }
    }
}

function updateNewBadgeLocalStorage(badgeSectionID, badgeLastModified){
    let defaultBadgeInfo = {
        lastModified: badgeLastModified,
        status: "notViewed",
    };

    localStorage.setItem(badgeSectionID, JSON.stringify(defaultBadgeInfo));
}

function showNewBadge(badge){
    $(badge).addClass('is-active');
}

function hideNewBadge(badge){
    $(badge).removeClass('is-active');
}